<div class="iframe-height">
    <iframe name="LTIIFrame" class="kognito-iframe lti-iframe" [src]="LTIIFrameSource | safe" id="LTIIFrame"
        scrolling=scrolling webkitallowfullscreen mozallowfullscreen
        allowfullscreen></iframe>
</div>
<div class="ehr-iframe-container ui-widget-content" [ngClass]="isMobile? 'ehr-iframe-container-devices':''" [@slideInOut]="IsLTIChildFrameVisible ? 'closed' : 'open'"
    [style.width.px]='width'>
    <div class="grabber"></div>
    <iframe name="LTIChildFrame" title="LTIChild" id="LTIChildFrame" class="iframe-width100 lti-child-iframe" scrolling="no"
        [src]="LTIChildFrame | safe"></iframe>
</div>